
  export default {
    name: "CrownIcon",
    props: {
      // eslint-disable-next-line vue/require-prop-types
      fill: {
        default: '#000000'
      }
    }
  }
